import { iconBaseProps, type IconProps } from "@/components/ui/icons/icon-base"

export const PlayIcon = ({ size = 14, ...props }: IconProps) => (
  <svg {...iconBaseProps(size, props)} fill="currentColor">
    <path d="M8 5v14l11-7z" />
  </svg>
)
